import { useEffect, useState } from 'react';
import { useAuth } from '../utils/AuthContext';
import { Link, useNavigate, useLocation} from 'react-router-dom';
import { getWishlist, removeFromWishlist, addToWishlist } from "../api/wishlist";
import { addToCart, getBids, placeBid } from '../api/commerce';
import { useParams } from "react-router-dom";
import { SidebarProvider } from "../components/SidebarContext";
import Loading from '../components/loading/Loading';
import Sidebar from '../components/Sidebar';
import SidebarToggle from '../components/SidebarToggle';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import "../css/Wishlist.css";
import "../css/ProductCard.css";


const Wishlist = () => {
  const [consoleError, setConsoleError] = useState("");
  const [items, setItems] = useState([])
  const [images, setImages] = useState ()
  const [videos, setVideos] = useState()
  const [is_biddable, setIsBiddable] = useState()
  const [productId, setproductId] = useState()
  const [price, setproductPrice] = useState()
  const [ownerUsername, setOwnerUsername] = useState()
  const [bids, setBids] = useState([])
  const [bidAmount, setBidAmount] = useState("")
  const [modalPurch, setModalPurch] = useState(null);
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams()
  const { user, loading, isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [user, loading, navigate, location]);

  const fetchList = () => {
    getWishlist()
      .then((res) => {
        if (Array.isArray(res.data)) {
          setItems(res.data);
        } 
        else if (res.data.results) {
          setItems(res.data.results);
        } else {
          setConsoleError("Unexpected response:", res.data);
          setItems([]);
        }
      })
      .catch((err) => setConsoleError("Error fetching wishlist:", err));
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchList();
    }
  }, [isAuthenticated]);

  const handleRemove = (id) => {
    removeFromWishlist(id).then(() => {
      setItems(items.filter(item => item.id !== id));
    });
  };

  const[selection, setSelection] = useState();
  const fetchModalItem = (id) => {
    const filteredItems = items.filter(item => item.id === id)
    if (filteredItems.length > 0) {
      const selectedItem = filteredItems[0]; 
      setSelection(selectedItem)
      setImages(selectedItem.product_images);
      setVideos(selectedItem.product_videos);
      setIsBiddable(selectedItem.product_is_biddable);
      setproductId(selectedItem.product);
      setproductPrice(selectedItem.product_price);
      setOwnerUsername(selectedItem.product_owner_username);
    } else {
      setConsoleError('Item not found!');
    }
  };

  const openModal = (id) => {
    setIsModalOpen(true);
    fetchModalItem(id);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  const safeImages = Array.isArray(images) ? images : images ? [images] : [];
  const safeVideos = Array.isArray(videos) ? videos : videos ? [videos] : [];
  
  const media = [
    ...safeImages.map(img => ({
      id: img.id,
      type: "image",
      src: img.image,
    })),
    ...safeVideos.map(vid => ({
      id: vid.id,
      type: "video",
      src: vid.video,
    })),
  ];
  
  // Sort: images first, then videos; within each type, sort by id
  const sortedMedia = media.sort((a, b) => {
    if (a.type !== b.type) {
      return a.type === "image" ? -1 : 1; // images come first
    }
    return (a.id ?? 0) - (b.id ?? 0); // sort by id within type
  });

  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexModal, setCurrentIndexModal] = useState(0);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentImageIndexModal, setCurrentImageIndexModal] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const goToPrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const goToNext = () => {
    if (currentIndex < sortedMedia.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const goToPreviousModal = () => {
    if (currentIndexModal > 0) {
      setCurrentIndexModal(currentIndexModal - 1);
    }
  };

  const goToNextModal = () => {
    if (currentIndexModal < sortedMedia.length - 1) {
      setCurrentIndexModal(currentIndexModal + 1);
    }
  };

  const currentItem = sortedMedia[currentIndex];
  const currentItemModal = sortedMedia[currentIndexModal];
  const mediaToDisplay = currentItem?.src || null;
  const mediaToDisplayModal = currentItemModal?.src || null;


  const normalizeNumber = (input) => {
    if (input == null || input === "") return "";
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    const arabicDigits = "٠١٢٣٤٥٦٧٨٩";
    let str = String(input).trim();
    // Convert Persian/Arabic digits to English
    str = str.replace(/[۰-۹]/g, (d) => persianDigits.indexOf(d));
    str = str.replace(/[٠-٩]/g, (d) => arabicDigits.indexOf(d));
    // Remove spaces and Persian thousands separator
    str = str.replace(/[\s٬]/g, "");
    // Convert Arabic decimal separator to dot
    str = str.replace(/٫/g, ".");
    const lastComma = str.lastIndexOf(",");
    const lastDot = str.lastIndexOf(".");
    if (lastComma > lastDot) {
      // European format: 1.234,56
      str = str.replace(/\./g, "");
      str = str.replace(",", ".");
    } else {
      // US format: 1,234.56
      str = str.replace(/,/g, "");
    }
    const num = Number(str);
    return Number.isNaN(num) ? null : num.toString();
  };

  // Handle Bidding
  const handleBid = async (productId, bidAmount, setBids) => {
    if (!isAuthenticated) {
      navigate(`/${lang}/login`, {
        state: { from: { pathname: `/${lang}/`} },
        replace: true,
      });
      return;
    }
    try {
      const numericAmount = parseFloat(normalizeNumber(bidAmount));
      await placeBid(productId, numericAmount);
      const updatedBids = await getBids(productId);
      setBids(updatedBids);
    } catch (err) {
      setConsoleError("Bid failed:", err);
    }
  };

  useEffect(() => {
    if (is_biddable) {
      getBids(productId)
        .then(setBids)
        .catch(err => setConsoleError(err));
    }
  }, [productId, is_biddable]);

  const highestBid = bids.length > 0 ? bids[0].bid_amount : price;

  // Add to Cart
  const handleAddToCart = async (productId) => {
    if (!isAuthenticated) {
      navigate(`/${lang}/login`, {
        state: { from: { pathname: `/${lang}/` } },
        replace: true,
      });
      return;
    }
    try {
      await addToCart(productId, 1);
      alert("Added to cart!");
    } catch (error) {
      setConsoleError("Add to Cart Error:", error);
      alert(setlang==="en"?"Something went wrong. Please try again.":"مشکلی رخ داد، لطفا دوباره وارد شو");
    }
  };
  
  const handleContact = () => {
    if (!isAuthenticated) {
      navigate(`/${lang}/login`, {
        state: { from: { pathname: `/${setlang}/contactform/${ownerUsername}/${productId}` } },
        replace: true,
      });
    }
  };


  // Add to Wishlist
  const [wishlist, setWishlist] = useState([]);
  
  useEffect(() => {
    if (!isAuthenticated) {
      setWishlist([]); 
      return;
    }

    getWishlist()
      .then(res => {
        if (Array.isArray(res.data)) {
          setWishlist(res.data);
        } else if (res.data.results) {
          setWishlist(res.data.results);
        }
      })
      .catch(err => {
        setConsoleError("Error fetching wishlist:", err.response?.data || err.message);
        setWishlist([]);
      });
  }, [isAuthenticated]);
  

  const handleToggleWishlist = (productId) => {
    if (!user) {
      navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      return;
    }
  
    // Check if product is already in wishlist
    const existingItem = wishlist.find((item) => item.product === productId);
  
    if (existingItem) {
      removeFromWishlist(existingItem.id)
        .then(() => {
          setWishlist(wishlist.filter((item) => item.id !== existingItem.id));
        })
        .catch((err) =>
          setConsoleError("Remove failed:", err.response?.data || err.message)
        );
    } else {
      addToWishlist(productId)
        .then((res) => {
          setWishlist([...wishlist, res.data]);
        })
        .catch((err) =>
          setConsoleError("Add failed:", err.response?.data || err.message)
        );
    }
  };

  // Transation
  dayjs.extend(utc);
  dayjs.extend(jalaliday);
  const toPersiDigits = (str) =>
    str.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])


  if (loading) return <Loading />;  
  return (
    <>
      <NavbarLog />
      <SidebarProvider side={setlang}>
      <SidebarToggle />
      <div className="wish-page">
        {setlang==="en" && 
          <Sidebar />
        }
        {loading ?(
        <p>{setlang==="en"?"Loading...":"در حال بارگذاری..."}</p>
        ) : Array.isArray(items) && items.length > 0 ? (
         <>
          <div className="wishlist-list">
              <h1>{setlang === "en" ? "My Wishlist" : "علاقه‌مندی‌های من"}</h1>
              {items.map((product) => (
                <div className='main-w-wrap'>
                <div key={product.id} className="wishlist-card">
                  {setlang === "en" ?
                  <div className= "wishlist-info">
                    <h4>{product.product_name}</h4>
                    <div className="wishlist-desc">{product.product_description || null}</div>
                    {product.product_price && <p><strong>Asking price: </strong> IRT {new Number(product.product_price).toLocaleString()}</p>}
                    {product.product_category && <p><strong>Category: </strong> {product.product_category}</p>}
                    {product.product_artist && <p><strong>By: </strong> {product.product_artist}</p>}
                    {product.product_is_biddable && product.product_bidding_deadline && <p><strong>Bidding Deadline: </strong> {dayjs.utc(product.product_bidding_deadline).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")}</p>}
                    {product.added_at && (
                      <p><small>Added to wishlist on: {dayjs.utc(product.added_at).calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")}</small></p>
                    )}
                  </div> 
                  :
                  <div className= "wishlist-info-fa">
                    <h4>{product.product_name}</h4>
                    {product.product_description && 
                      <div className='info-row-fa'>
                        <div className="wishlist-desc"><p> {product.product_description}</p></div>
                        <div style={{ fontWeight:"bold"}}><span> :توضیحات</span></div> 
                      </div>
                    }
                    {product.product_price && 
                      <div className='info-row-fa'>
                        <div><span>تومان</span></div>
                        <div><span> {toPersiDigits(new Number(product.product_price).toLocaleString())}</span></div>
                        <div style={{ fontWeight:"bold"}}><span> :قیمت درخواستی</span></div> 
                      </div>
                    }
                    {product.product_category && 
                      <div className='info-row-fa'>
                        <div><span> {product.product_category}</span></div>
                        <div style={{ fontWeight:"bold"}}><span> :دسته‌بندی</span></div> 
                      </div>
                    }
                    {product.product_artist && 
                      <div className='info-row-fa'>
                        <div><span> {product.product_artist}</span></div>
                        <div style={{ fontWeight:"bold"}}><span> :اثر</span></div> 
                      </div>
                    }
                    {product.product_is_biddable && product.product_bidding_deadline && 
                      <div className='info-row-fa'>
                        <div><span> {toPersiDigits(dayjs.utc(product.product_bidding_deadline).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm"))}</span></div>
                        <div style={{ fontWeight:"bold"}}><span> :مهلت شرکت در مزایده تا تاریخ</span></div> 
                      </div>
                    }
                    {product.added_at && (
                      <p><small>{toPersiDigits(dayjs.utc(product.added_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm"))} :تاریخ اضافه شدن به لیست علاقه‌مندی‌ها</small></p>
                    )}
                  </div> 
                  }
                  <div className="wishlist-images">
                    {/* Images */}
                    {Array.isArray(product.product_images) && product.product_images.length > 0 &&
                      product.product_images.map((img) => (
                        <img
                          key={img.id}
                          src={img.image}
                          alt={product.product_name}
                          onClick={() => openModal (product.id)}
                          className="wishlist-image"
                        />
                      ))
                    }

                    {/* Videos */}
                    {Array.isArray(product.product_videos) && product.product_videos.length > 0 &&
                      product.product_videos.map((vid) => (
                        <video
                          key={vid.id} 
                          src={vid.video}
                          onClick={() => openModal (product.id)}
                          controls
                          className="wishlist-image"
                        />
                      ))
                    }

                    {/* Fallback if no media */}
                    {(!product.product_images?.length && !product.product_videos?.length) && (
                      <p className="wishlist-nomedia">{setlang === "en" ? "No media available" : "عکسی وجود ندارد" }</p>
                    )}
                  </div>
                </div>
                <div className="wishlist-actions">
                  <button 
                    className="btn-remove" onClick={() => handleRemove(product.id)}>
                    {setlang === "en" ? "Remove" : "حذف" }
                  </button>
                  <button onClick={() => openModal(product.id)} className="btn"> {setlang === "en" ? "View Details" : "نمایش آگهی" } </button>
                </div>
                </div>
              ))}

              {/* Modal View */}
                  <div>
                    {isModalOpen && (
                      <div onClick={handleOverlayClick} className="modal-overlay">
                        <div className="modal-card-prod" onClick={e => e.stopPropagation()}>
                          {/* Close Button */}
                          <button onClick={closeModal} className="close-button">
                            &#10005;
                          </button>

                          {/* Image + Info Layout */}
                          <div className="modal-body-prod">
                            {/* Left: Image */}
                            <div className="modal-image-section">
                              <div className="modal-image-cont">
                                {currentItemModal ? (
                                  currentItemModal.type === "image" ? (
                                    <img src={mediaToDisplayModal} 
                                    alt={selection.name}
                                    className="modal-image-large"
                                    onClick={openModal}
                                    />
                                  ) : (
                                    <video 
                                    src={mediaToDisplayModal}  
                                    controls 
                                    className="modal-image-large"
                                    onClick={openModal}
                                    />
                                  )
                                ) : (
                                  <img src={mediaToDisplayModal} className="modal-image-large" onClick={openModal}/>
                                )}
                              </div>

                              {/* Navigation Arrows */}
                              <button
                                onClick={goToPreviousModal}
                                className="nav-arrow left"
                                hidden={currentIndexModal === 0}
                              >
                                &#8592;
                              </button>
                              <button
                                onClick={goToNextModal}
                                className="nav-arrow right"
                                hidden={currentIndexModal >= sortedMedia.length - 1}
                              >
                                &#8594;
                              </button>
                            </div>

                            {/* Right: Product Info */}
                              <div className="modal-info-section">
                                <h3 className="modal-title">{selection.product_name}</h3>
                                {selection.product_description && (
                                  setlang === "en" ? (
                                    <div className="info-row">
                                      <div><span className="info-label">Description: </span></div>
                                      <p className="modal-description"> {selection.product_description}</p>
                                    </div>
                                  ):(
                                    <div className= "info-row-fa">
                                      <div><p className="modal-description"> {selection.product_description}</p></div>
                                      <div><span className="info-label"> :توضیحات</span></div>
                                    </div>
                                  )
                                )}
                                {selection.product_artist && (
                                  setlang === "en" ? (
                                  <div className="info-row">
                                    <span className="info-label">By: </span>
                                    <span className="modal-author"> {selection.product_artist}</span>
                                  </div>
                                  ):(
                                  <div className="info-row-fa">
                                    <span className="modal-author"> {selection.product_artist}</span>
                                    <span className="info-label"> :اثر</span>
                                  </div>
                                  )
                                )}
                                {selection.product_category && (
                                  setlang === "en" ? (
                                  <div className="info-row">
                                    <span className="info-label">Category: </span>
                                    <div><span className="modal-author">{selection.product_category}</span></div>
                                  </div>
                                  ):(
                                  <div className="info-row-fa">
                                    <div><span className="modal-author">{selection.product_category}</span></div>
                                    <span className="info-label"> :دسته‌بندی</span>
                                  </div>
                                  )
                                )}
                                {selection.product_style && (
                                  setlang === "en" ? (
                                  <div className="info-row">
                                    <span className="info-label">Style: </span>
                                    <div><span className="modal-author"> {selection.product_style}</span></div>
                                  </div>
                                  ):(
                                  <div className="info-row-fa">
                                    <div><span className="modal-author"> {selection.product_style}</span></div>
                                    <span className="info-label"> :استایل</span>
                                  </div>
                                  )
                                )}
                                {selection.product_material && (
                                  setlang === "en" ? (
                                    <div className= "info-row" >
                                      <span className="info-label">Material: </span>
                                      <div><span className="modal-author">{selection.product_material}</span></div>
                                    </div>
                                  ):(
                                    <div className= "info-row-fa">
                                      <div><span className="modal-author">{selection.product_material}</span></div>
                                      <span className="info-label"> :جنس ساخت</span>
                                    </div>
                                  )
                                )}
                                {setlang === "en" ? (
                                  <div className="info-row">
                                    <span className="info-label">{selection.product_length ? "Dimensions: ": selection.product_width ? "Dimensions: ": selection.product_height ? "Dimensions: ": null}</span>
                                    <div><span className="modal-author">{ selection.product_length ? "L " + new Number(selection.product_length).toLocaleString() + " cm x " : " " }{ selection.product_width ? "W " + new Number(selection.product_width).toLocaleString()  + " cm x " : " " }{ selection.product_height ? "H " + new Number(selection.product_height).toLocaleString() + " cm" : " " }</span></div>
                                  </div>
                                ):(
                                  <div className="info-row-fa">
                                    <div><span className="modal-author">{ selection.product_length ? toPersiDigits(new Number(selection.product_length).toLocaleString())  + " طول x " : " " }{ selection.product_width ? toPersiDigits(new Number(selection.product_width).toLocaleString()) + " عرض x " : " " }{ selection.product_height ?  toPersiDigits(new Number(selection.product_height).toLocaleString()) + " ارتفاع" : " " }</span></div>
                                    <span className="info-label">{selection.product_length ? " :(سانتیمتر)ابعاد": selection.product_width ? " :(سانتیمتر)ابعاد": selection.product_height ? " :(سانتیمتر)ابعاد":null}</span>
                                  </div>
                                )}
                                {selection.product_weight && (
                                  setlang === "en" ? (
                                  <div className="info-row">
                                    <span className="info-label">Weight: </span>
                                    <div><span className="modal-author">{selection.product_weight} kg</span></div>
                                  </div>
                                  ):(
                                  <div className="info-row-fa">
                                    <div><span className="modal-author">{toPersiDigits(selection.product_weight)} kg</span></div>
                                    <span className="info-label"> :وزن</span>
                                  </div>
                                  )
                                )}
                                {selection.product_feature_one && (
                                  setlang === "en" ? (
                                  <div className="info-row">
                                    <span className="info-label">Features: </span>
                                    <div><span className="modal-author">{selection.product_feature_one}</span>
                                    <span className="modal-author">{selection.product_feature_two}</span></div>
                                  </div>
                                  ):(
                                  <div className="info-row-fa">
                                    <div><span className="modal-author">{selection.product_feature_two}</span>
                                    <span className="modal-author">{selection.product_feature_one}</span></div>
                                    <span className="info-label"> :ویژگی‌ها</span>
                                  </div>
                                  )
                                )}

                              {setlang === "en" ? (
                                <div className="info-row">
                                  <span className="info-label">Placed on: </span>
                                  <span className="modal-date">{dayjs.utc(selection.product_created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD")}</span>
                                </div>
                              ):(
                                <div className="info-row-fa">
                                  <span className="modal-date">{toPersiDigits(dayjs.utc(selection.product_created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD"))}</span>
                                  <span className="info-label"> :تاریخ آگهی</span>
                                </div>
                              )}

                              {setlang === "en" ? 
                                <div className="info-row">
                                  <span className="info-label">Asking Price: </span>
                                  <span className="modal-price">IRT {new Number(selection.product_price).toLocaleString()}</span>
                                </div> :
                                <div className="info-row-fa">
                                  <span className="modal-price-fa">تومان</span>
                                  <span className="modal-price-fa">{toPersiDigits(new Number(selection.product_price).toLocaleString())}</span>
                                  <span className="info-label"> :قیمت درخواستی</span>
                                </div>
                              }

                              {/* Actions */}
                              <div className="modal-actions">
                                {selection.product_is_biddable ? (
                                  <>
                                    {isAuthenticated ? (
                                      <Link style={{textDecoration:"none"}} to={`/${setlang}/contactform/${selection.product_owner}/${selection.product}`}>
                                        <button className="secondary-button">{setlang === "en" ? "Contact Seller" : "تماس با فروشنده" }</button>
                                      </Link>
                                    ) : (
                                      <button
                                      onClick={handleContact}
                                      className="secondary-button">{setlang === "en" ? "Contact Seller" : "تماس با فروشنده" }</button>
                                    )}

                                    {setlang === "en" ? 
                                    <button className="secondary-button" onClick={() => handleToggleWishlist(productId)}>
                                      {wishlist.some((item) => item.product === productId)
                                        ? "Remove from Wishlist"
                                        : "Add to Wishlist"}
                                    </button> :
                                    <button className="secondary-button" onClick={() => handleToggleWishlist(productId)}>
                                      {wishlist.some((item) => item.product === productId)
                                        ? "حذف از علاقه‌مندی‌ها"
                                        : "اضافه به علاقه‌مندی‌ها"}
                                    </button>
                                    }
                                      <p>IRT <input
                                        type="number"
                                        className="bid-section"
                                        value={bidAmount}
                                        onChange={e => setBidAmount(e.target.value)}
                                        placeholder={setlang === "en" ? "Enter your bid" : "قیمت پیشنهادی" }
                                      /></p>
                                      <button
                                        onClick={() => handleBid(selection.product, bidAmount, setBids)}
                                        className="bid-button"
                                      >{setlang === "en" ? "Place Bid" : "پیشنهاد خرید" }</button>

                                      <div className= {setlang === "en" ? "bid-footnote" : "bid-footnote-fa" }>
                                        {setlang === "en" ? 
                                        <p>
                                          <strong>Note:</strong> You may place multiple bids before the auction deadline. 
                                          Only the <span className="highlight">highest valid bid</span> at the time of the deadline 
                                          will be considered for selection. Once the deadline has passed, no further bids will be accepted.
                                        </p> : 
                                        <p>
                                          <strong>توجه: </strong> 
                                            شما می‌توانید برای آیتم‌های مزایده‌ای تا پایان زمان شرکت در مزایده بیش از یک بار پیشنهاد قیمت بدهید و یا پیشنهادهای
                                              خود را حذف کنید. بالاترین پیشنهاد در لحظه پایان مزایده به عنوان برنده مزایده و خریدار کالا مشخص خواهد شد. در صورت برنده شدن
                                              در مزایده مبلغ رزرو شده از حساب شما کسر خواهد شد و  شما می‌توانید فرآیند دریافت کالا را در صفحه سفارش‌های خود دنبال کنید
                                        </p>
                                        }
                                      </div>
                                    
                                    {/* Bid History */}
                                    <div className={setlang === "en" ? "bid-history" : "bid-history-fa" }>
                                      <h4>{setlang === "en" ?  "Bid History" : "مزایده در حال انجام" }</h4>
                                      {Array.isArray(bids) && bids.length > 0 ? (
                                        <table className="bid-table">
                                          <thead>
                                            <tr>
                                              <th>{setlang === "en" ? "Bidder" : "کاربر" }</th>
                                              <th>{setlang === "en" ? "Amount" : "پیشنهاد" }</th>
                                              <th>{setlang === "en" ? "Date" : "تاریخ" }</th>
                                              <th>{setlang === "en" ? "Status" : "وضعیت" }</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {bids.map((b, index) => (
                                              <tr key={b.id}>
                                                <td>{b.bidder_name}</td>
                                                {setlang==="en"? (
                                                  <>
                                                    <td>IRT {new Number(b.bid_amount).toLocaleString()}</td>
                                                    <td>{dayjs.utc(b.created_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")}</td>
                                                  </>
                                                ):(
                                                  <>
                                                    <td>{toPersiDigits(new Number(b.bid_amount).toLocaleString())} تومان</td>
                                                    <td>{toPersiDigits(dayjs.utc(b.created_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm"))}</td>
                                                  </>
                                                )
                                                }  
                                                <td>
                                                  {index === 0 ? (
                                                    <span className="highest-bid">{setlang === "en" ?  "Highest" : "بالا" }</span>
                                                  ) : (
                                                    <span className="outbid">{setlang === "en" ?  "Outbid" : "پایین" }</span>
                                                  )}
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      ) : (
                                        <p>{setlang === "en" ? "Place the first bid" : "اولین شرکت کننده در مزایده باشید" }</p>
                                      )}
                                    </div>     
                                  </>
                                ) : (
                                  <>
                                    {isAuthenticated ? (
                                      <Link style={{textDecoration:"none"}} to={`/${setlang}/contactform/${ownerUsername}/${productId}`} >
                                        <button className="secondary-button">{setlang === "en" ? "Contact Seller" : "تماس با فروشنده" }</button>
                                      </Link>
                                    ) : (
                                      <button
                                        onClick={handleContact}
                                        className="secondary-button">{setlang === "en" ? "Contact Seller" : "تماس با فروشنده" }</button>
                                    )}
                                    
                                    {setlang === "en" ? 
                                    <button className="secondary-button" onClick={() => handleToggleWishlist(productId)}>
                                      {wishlist.some((item) => item.product === productId)
                                        ? "Remove from Wishlist"
                                        : "Add to Wishlist"}
                                    </button> :
                                    <button className="secondary-button" onClick={() => handleToggleWishlist(productId)}>
                                      {wishlist.some((item) => item.product === productId)
                                        ? "حذف از علاقه‌مندی‌ها"
                                        : "اضافه به علاقه‌مندی‌ها"}
                                    </button>
                                    }
                                    
                                    {selection.product_bidzone_stored ? 
                                      <button className="secondary-button" onClick={() => handleAddToCart(productId)}>{setlang === "en" ? "Add to Cart" : "اضافه به سبد خرید"}</button>
                                      :
                                      <button className="secondary-button" onClick={() => setModalPurch(true)}>{setlang === "en" ? "Add to Cart" : "اضافه به سبد خرید"}</button>
                                    }

                                    {selection.product_bidzone_stored ? 
                                      <Link style={{textDecoration:"none"}} to={`/${setlang}/cart`}>
                                        <button onClick={() => handleAddToCart(productId)} className="secondary-button"> 
                                          {setlang === "en" ? "Buy Now" : "خرید مستقیم" } 
                                        </button>
                                      </Link>
                                    :
                                      <button onClick={() => setModalPurch(true)} className="secondary-button"> 
                                        {setlang === "en" ? "Buy Now" : "خرید مستقیم" } 
                                      </button>
                                    }


                                    {modalPurch && (
                                      <div onClick={handleOverlayClick} className="modal-overlay" > 
                                        <div className={setlang==="en"?"purch-modal-container-en":"purch-modal-container-fa"} onClick={e => e.stopPropagation()}>
                                          <h1>{setlang==="en"?"Purchase":"روش خرید"}</h1>
                                          <p>{setlang==="en"?"This article is not stored by Bidzone, please contact the seller for purchasing":"این محصول توسط BidZone نگهداری نمی‌شود. برای خرید این محصول مستقیم با فروشنده تماس بگیرید"}</p>
                                          
                                          <div style={{display:"flex", placeContent:"center"}}>
                                            <button onClick={() => setModalPurch(false)} className="c-modal-button">{setlang==="en"?"Close":"بستن"}</button>
                                          
                                            {isAuthenticated ? (
                                              <Link style={{textDecoration:"none"}} to={`/${setlang}/contactform/${ownerUsername}/${productId}`} >
                                                <button className="c-modal-button">{setlang === "en" ? "Contact Seller" : "تماس با فروشنده" }</button>
                                              </Link>
                                            ) : (
                                              <button
                                                onClick={handleContact}
                                                className="c-modal-button">{setlang === "en" ? "Contact Seller" : "تماس با فروشنده" }</button>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )}    
                                  </>
                                )}
                              </div>           
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
            </div>
          </>
        ) : (
          <div className="wishlist-list">
            <p>{setlang === "en" ?  "Your wishlist is empty" : "لیست مورد علاقه شما خالی می‌باشد" }</p>
          </div>
        )}
        {setlang==="fa" && 
          <Sidebar />
        }
      </div>
      </SidebarProvider>
      <Footer />
    </>
  );
};

export default Wishlist;